import React from 'react';
import mergeProps from './mergeProps';

export default function cloneElement(element, ...props) {
    if (typeof element === 'string') return element;
    if (!React.isValidElement(element)) return null;

    const mergedProps = mergeProps(element.props, ...props);
    return React.cloneElement(element, mergedProps);
}
